interface AndroidInterface {
  sendUserData: (data: string) => void;
  sendChannelId: (channelId: string) => void;
  unsetChannelId: () => void;
  openBrowser: (url: string) => void;
  // Add other Android methods here as needed
}

class AndroidBridge {
  private static instance: AndroidBridge;
  private android: AndroidInterface | null = null;

  private constructor() {
    this.android = (window as any).Android || null;
  }

  public static getInstance(): AndroidBridge {
    if (!AndroidBridge.instance) {
      AndroidBridge.instance = new AndroidBridge();
    }
    return AndroidBridge.instance;
  }

  public sendUserData(data: any): void {
    try {
      if (this.android && typeof this.android.sendUserData === "function") {
        this.android.sendUserData(JSON.stringify(data));
      } else {
        console.log("Android interface not available");
      }
    } catch (error) {
      console.error("Error sending data to Android:", error);
    }
  }

  public sendChannelId(channelId: string): void {
    try {
      if (this.android && typeof this.android.sendChannelId === "function") {
        this.android.sendChannelId(channelId);
      } else {
        console.log("Android interface not available");
      }
    } catch (error) {
      console.error("Error sending channel ID to Android:", error);
    }
  }

  public unsetChannelId(): void {
    try {
      if (this.android && typeof this.android.unsetChannelId === "function") {
        this.android.unsetChannelId();
      } else {
        console.log("Android interface not available");
      }
    } catch (error) {
      console.error("Error unsetting channel ID on Android:", error);
    }
  }

  public openBrowser(url: string): void {
    try {
      if (this.android && typeof this.android.openBrowser === "function") {
        this.android.openBrowser(url);
      } else {
        // Fallback: not running inside the Android bridge - open in a new
        // browser context instead of navigating away inside the WebView.
        window.open(url, "_blank", "noopener,noreferrer");
      }
    } catch (error) {
      console.error("Error opening browser:", error);
    }
  }

  public isAndroidAvailable(): boolean {
    return this.android !== null;
  }
}

export default AndroidBridge.getInstance();
